.chatMessage {
    width: 100%;
    padding: 20px;
    min-height: 150px;
}

.chatmessage {
    background-color: transparent;
    border-radius: 5px;
    padding: 10px;
    margin: 10px;
    opacity: 0;
    animation: fadeIn 0.5s ease-in-out forwards;
}

.citation_class {
    font-size: 12px;
    color: #31568e;
    font-weight: 700;
    font-style: normal;
}
